export default __webpack_public_path__ + "static/media/regulatory--no-tractors--g1.a2437580.png";